export const MAIL_DOMAINS_REPORT_ID = 'mail-domains';
